<template>
    <div>
        <div v-if="!error && !loading" class="content">
            <template v-if="singlepage">
                <div class="page box">
                    <h3 class="title is-4">Bureau</h3>
                    <div>Composition du bureau :</div>
                    <br>
                    <table class="table is-fullwidth has-background-white">
                        <tr v-for="(membre) in membres" v-bind:key="membre._id">
                            <td>{{membre.fonction}}</td>
                            <td>{{membre.prenom}} {{membre.nom}}</td>
                        </tr>
                    </table>
                </div>
                </template>
                <template v-else>
                    <table class="table is-fullwidth has-background-light">
                        <tr v-for="(membre) in membres" v-bind:key="membre._id">
                            <td>{{membre.fonction}}</td>
                            <td>{{membre.prenom}} {{membre.nom}}</td>
                        </tr>
                    </table>
                </template>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data: function() {
        return {
            loading: true,
            page: null,
            error: null,
            membres: [],
        }
    },
    name: 'Bureau',
    props: {
        singlepage: Boolean
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_bureau
            axios({
                    method: 'get',
                    url: fetchurl
                }).then(function(response) {
                    vm.loading = false
                    vm.membres = response.data.entries
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 40px;
}
</style>